import type { ChatPresentation, ChatSurface, ResourceLayout } from "../types/chat";

export type ResolvedChatPresentation = Exclude<ChatPresentation, "responsive">;

export interface ResolveChatPresentationInput {
  presentation: ChatPresentation;
  surface: ChatSurface;
  layoutOverride?: ResourceLayout;
  agentLayout?: ResourceLayout;
}

/**
 * Resolves a host's requested chat presentation into the concrete shell.
 *
 * Candidate `responsive` presentation keeps the governing resource visible by
 * docking `split` and `auto` chats. The dock itself becomes a modal below its
 * shared wide-screen breakpoint; an explicit inline resource always remains in
 * the takeover, where the inline resource affordance is available.
 */
export function resolveChatPresentation(
  input: ResolveChatPresentationInput,
): ResolvedChatPresentation {
  if (input.presentation !== "responsive") {
    return input.presentation;
  }

  const resourceLayout = input.layoutOverride && input.layoutOverride !== "auto"
    ? input.layoutOverride
    : input.agentLayout;

  return input.surface === "candidate" && resourceLayout !== "inline"
    ? "dock"
    : "takeover";
}

/** Whether the resolved shell must provide modal focus/scroll/ARIA behaviour. */
export function isModalChatPresentation(
  presentation: ResolvedChatPresentation,
  isWide: boolean,
): boolean {
  return presentation === "takeover" || !isWide;
}
